var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchLoupeLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#999EA6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66051 11.8415C3.80451 11.8415 1.47951 9.51749 1.47951 6.66049C1.47951 3.80449 3.80451 1.48049 6.66051 1.48049C9.51751 1.48049 11.8415 3.80449 11.8415 6.66049C11.8415 9.51749 9.51751 11.8415 6.66051 11.8415ZM14.4125 13.7375L11.7965 11.1205C11.7595 11.0825 11.7125 11.0645 11.6705 11.0365C12.6955 9.86449 13.3215 8.33649 13.3215 6.66049C13.3215 2.98849 10.3335 0.000488281 6.66051 0.000488281C2.98851 0.000488281 -0.000488281 2.98849 -0.000488281 6.66049C-0.000488281 10.3335 2.98851 13.3215 6.66051 13.3215C8.15051 13.3215 9.52351 12.8235 10.6345 11.9935C10.6675 12.0535 10.6985 12.1155 10.7495 12.1665L13.3665 14.7835C13.6555 15.0725 14.1235 15.0725 14.4125 14.7835C14.7025 14.4945 14.7025 14.0255 14.4125 13.7375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLoupeLeft);
export default __webpack_public_path__ + "static/media/search_loupe_left.1999daf3bb51e3f10e81c83dcf3efc23.svg";
export { ForwardRef as ReactComponent };